<template>
    <div class="upAppendix">
        <el-upload action="string"
                   class="upload-demo"
                   :on-remove="handleRemove"
                   :before-remove="beforeRemove"
                   :http-request="upFile"
                   multiple
                   :file-list="File">
            <div class="add-wrap">
                <p class="add">
                    <i class="el-icon-upload2"></i>上传附件
                </p>
            </div>
            <el-progress :percentage="progress" v-if="isUpload"/>
        </el-upload>
    </div>
</template>

<script type="text/ecmascript-6">
    export default {
        name: 'up-appendix',
        props: {
            file: {
                type: Array
            },
            fileType: {
                type: String,
                default: '1'
            }
        },
        data() {
            return {
                isUpload: false, // 正在上传
                showProgress: false,
                uploadPercent: '', // 上传进度
                currentFile: {},
                defaultImg: this.$Public.defaultImg,
                File: this.file,
                progress: 0 // 进度条
            };
        },
        created() {
        },
        methods: {
            beforeRemove(file) {
                return this.$confirm(`确定移除 ${file.name}？`);
            },
            handleRemove(file) {
                this.File = this.File.filter(item =>
                    item !== file
                );
                this.$emit('getFile', this.File);
            },
            upFile(param) {
                // 上传图片
                this.progress = 0;
                let file = param.file;
                if (!file) {
                    return;
                }
                let time = setInterval(() => {
                    this.progress += 1;
                    // console.log(1111, this.progress);
                    if (this.progress >= 98) {
                        clearTimeout(time);
                    }
                }, Math.random()*2000);
                this.isUpload = true;
                this.httpUploadImg({ type: this.fileType, file: file }).then(res => {
                    clearTimeout(time);
                    this.progress = 100;
                    let item = {
                        name: param.file.name,
                        url: res
                    };
                    this.File.push(item);
                    this.$emit('getFile', this.File);
                    setTimeout(() => {
                        this.isUpload = false;
                    }, 1000);
                }, (res) => {
                });
            }
        },
        watch: {
            file(val) {
                console.log(22222, val);
                this.File = val;
            }
        }
    };
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    @import '~assets/main.styl';

    .upAppendix {
        flex-x(flex-start, flex-start);
        .add-wrap {
            position relative
            width: 100px
            height: 30px
            background white
            border: 1px solid border-color
            border-radius(3px)
            flex-center()
            .add {
                color: blue
            }
            p {
                text-align center
                color: gray6
            }
        }
        input {
            width: 100%
            height: 100%
            opacity 0
            position absolute
            top: 0
            left: 0
        }
    }

    .list {
        flex-y()
    }

    .pdf {
        width: 900px
        height: 700px
        margin-left 120px
    }

    p {
        float: left;
    }
</style>
